export default "__VITE_ASSET__BVtKcPaL__"